import React from 'react';
import {Button, Message} from 'tinper-bee';
import Layout from '../Layout';
import './index.css';
import * as util from '../../utils';

class ExperienceApply extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            productVersion: sessionStorage.getItem('experienceApply_version') || '',
            submitLoading: false,
            projectTypeList: [],
        };
    }

    componentDidMount() {
        // begin add for yoncode体验资格: from=yoncode时隐藏header和菜单 at 20260522 ticket
        if (new URLSearchParams(window.location.search).get('from') === 'yoncode' || new URLSearchParams(window.location.search).get('ticket')) {
            document.body.classList.add('from-yoncode');
        }
        // end add for yoncode体验资格: from=yoncode时隐藏header和菜单 at 20260522
        // begin modify for yoncode体验资格: 登录校验增加延迟重试机制，避免登录回调写入localStorage前就检查 at 20260522
        this.checkLoginWithRetry();
        // end modify for yoncode体验资格: 登录校验增加延迟重试机制 at 20260522
    }

    checkLoginWithRetry = () => {
        // begin add for yoncode体验资格: 从登录页返回时检测标记，轮询等待localStorage写入完成 at 20260522
        const REDIRECTING_KEY = 'experienceApply_redirecting';
        const TOTAL_MS = 10000;
        const INTERVAL_MS = 2000;
        if (sessionStorage.getItem(REDIRECTING_KEY)) {
            sessionStorage.removeItem(REDIRECTING_KEY);
            let elapsed = 0;
            const timer = setInterval(() => {
                elapsed += INTERVAL_MS;
                if (this.checkLogin()) {
                    clearInterval(timer);
                    this.loadProjectTypes();
                } else if (elapsed >= TOTAL_MS) {
                    clearInterval(timer);
                    this.goLogin();
                }
            }, INTERVAL_MS);
            return;
        }
        // end add for yoncode体验资格: 从登录页返回时检测标记，轮询等待localStorage写入完成 at 20260522
        if (!this.checkLogin()) {
            sessionStorage.setItem(REDIRECTING_KEY, '1');
            this.goLogin();
            return;
        }
        this.loadProjectTypes();
    };

    componentWillUnmount() {
        // begin add for yoncode体验资格: 移除body class at 20260522
        document.body.classList.remove('from-yoncode');
        // end add for yoncode体验资格: 移除body class at 20260522
    }

    loadProjectTypes = async () => {
        try {
            const result: any = await util.get('/yoncode/dict/list', { dict_type: 'project_type' });
            if (result.status === 200 && result.data && result.data.length > 0) {
                const raw = result.data[0].dict_value;
                const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
                this.setState({ projectTypeList: parsed });
            }
        } catch (e) {
            // 忽略错误
        }
    };

    onVersionSelect = (value: string) => {
        this.setState({ productVersion: value });
        sessionStorage.setItem('experienceApply_version', value);
    };

    checkLogin() {
        const user = localStorage.getItem('user');
        // begin modify for yoncode体验资格: 补充'null'字符串判断 at 20260522
        if (!user || user === 'null' || user === 'undefined') {
            return false;
        }
        // end modify for yoncode体验资格: 补充'null'字符串判断 at 20260522
        return true;
    }

    goLogin() {
        const longinLink = document.querySelector('.login-text');
        // @ts-ignore
        if (longinLink && longinLink.click) {
            console.log('Redirecting to login page...');    
            // @ts-ignore 
            longinLink.click();
        } 
    }

    async handleSubmit() {
        const { productVersion } = this.state;

        if (!productVersion) {
            Message.create({ content: '请选择 YonBIP/YonSuite 版本', color: 'warning' });
            return;
        }

        this.setState({ submitLoading: true });
        try {
            const result: any = await util.post('/yoncode/experienceApply/submit', {
                productVersion,
            });
            if (result.status === 200) {
                Message.create({ content: '提交成功', color: 'success' });
                this.setState({ productVersion: '' });
                sessionStorage.removeItem('experienceApply_version');
            } else {
                Message.create({ content: result.message || '提交失败', color: 'danger' });
            }
        } catch (e) {
            Message.create({ content: '提交失败，请稍后重试', color: 'danger' });
        } finally {
            this.setState({ submitLoading: false });
        }
    }

    render() {
        const { productVersion, submitLoading, projectTypeList } = this.state;

        return (
            <div className="experience-apply-wrapper">
                <div className="experience-apply-form">
                    <div className="form-title">体验资格申请</div>
                    <div className="form-item">
                        <div className="form-label">YonBIP/YonSuite 版本</div>
                        <div className="form-control-wrap">
                            <div className="version-tag-list">
                                {projectTypeList.map((opt: any, idx: number) => (
                                    <div
                                        key={opt.key || `type-${idx}`}
                                        className={`version-tag ${productVersion === opt.key ? 'active' : ''}`}
                                        onClick={() => this.onVersionSelect(opt.key)}
                                    >
                                        {opt.label}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="form-actions">
                        <Button
                            colors={'primary'}
                            loading={submitLoading}
                            onClick={() => this.handleSubmit()}
                        >
                            提交申请
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Layout(ExperienceApply, 'experience-apply-page');
